import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';

import { IDispatchManufactoringFilter } from '../models/filters/dispatchManufactoringFilter';
import { IDispatchManufactoringForm } from '../models/forms/dispatchManufactoringForm';
import { IDispatchManufactoringPDTO } from '../models/dtos/dispatchManufactoringPDTO';
import { ILotComposition } from '../models/lotComposition';
import { IHeteroAvailableDispatch } from '../models/heteroAvailableDispatch';
import { IPrevisionalDispatch } from '../models/previsionalDispatch';
import { API_CENTRE } from './config';
import { apiCallWithAuth } from '../helper/apiManager';

export default class DispatchManufactoringServices extends _o2sService {
   protected static override mainUrl:string = API_CENTRE + '/api/v1/DispatchManufactoring';
   protected static override getUrlFilter<F extends IDispatchManufactoringFilter>(filter?: F): string {;
       let url = super.getUrlFilter(filter as IFilter);
       if (filter != null) 
       {
            if (filter.manufactoringProductionId != null)
                url += '&ManufactoringProductionId=' + filter.manufactoringProductionId;
            if (filter.centerId != null)
                url += '&CenterId=' + filter.centerId;
            if (filter.belongsToLotId != null)
                url += '&BelongsToLotId=' + filter.belongsToLotId;
            if (filter.partOfLotId != null)
                url += '&PartOfLotId=' + filter.partOfLotId;
            if (filter.loadProduction != undefined)
                url += '&LoadProduction=' + filter.loadProduction;
            if (filter.archived != undefined)
                url += '&Archived=' + filter.archived;
            if (filter.dateFrom != null)
                url += '&DateFrom=' + filter.dateFrom.toISOString();
       }
       return url;
   }

   public static override toDTO(dic: IDispatchManufactoringForm): IDispatchManufactoringPDTO {
       const dto = super.toDTO(dic) as IDispatchManufactoringPDTO;
       return dto;
   }

    public static async resendStock(centerCodeSpecies: string) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + `/resendstock?centerBusinessKey=${centerCodeSpecies}`);
            return this.ReturnObject(result);
        } catch (err) {
            return this.ReturnError(err);
        }
    }

    /**
     * Orientation hétérospermie transactionnelle
     */
    public static async orientHetero(request: any) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + '/orient-hetero', 'post', request);
            return this.ReturnListObject(result);
        } catch (err: any) {
            return this.ReturnError(err);
        }
    }

    /**
     * Annulation batch transactionnelle
     */
    public static async cancelBatch(dispatchIds: number[]) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + '/cancel-batch', 'post', { dispatchIds });
            return this.ReturnListObject(result);
        } catch (err: any) {
            return this.ReturnError(err);
        }
    }

    /**
     * Retourne la composition d'un lot hétérospermie (verrats, volumes, infos centre)
     */
    public static async getLotComposition(lotId: number): Promise<{ error: boolean, data: ILotComposition | null }> {
        try {
            let result = await apiCallWithAuth(this.mainUrl + `/lot-composition/${lotId}`);
            return { error: false, data: result.data as ILotComposition };
        } catch (err: any) {
            return { error: true, data: null };
        }
    }

    /**
     * Retourne les dispatches mono orientés H disponibles pour la sélection hétérospermie.
     * Données pré-résolues côté serveur (pas d'hydratation frontend).
     */
    public static async getHeteroAvailable(centerId: number): Promise<{ error: boolean, data: IHeteroAvailableDispatch[] }> {
        try {
            let result = await apiCallWithAuth(this.mainUrl + `/hetero-available/${centerId}`);
            return { error: false, data: result.data as IHeteroAvailableDispatch[] };
        } catch (err: any) {
            return { error: true, data: [] };
        }
    }

    /**
     * Retourne les dispatches prévisionnels (non validés) du centre avec données pré-résolues.
     */
    public static async getPrevisionalStock(centerId: number): Promise<{ error: boolean, data: IPrevisionalDispatch[] }> {
        try {
            let result = await apiCallWithAuth(this.mainUrl + `/previsional-stock/${centerId}`);
            return { error: false, data: result.data as IPrevisionalDispatch[] };
        } catch (err: any) {
            return { error: true, data: [] };
        }
    }

    /**
     * Validation batch transactionnelle (dispatch + stock movement atomique)
     */
    public static async validateWithStock(items: any[]) {
        try {
            let result = await apiCallWithAuth(this.mainUrl + '/validate-with-stock', 'post', { items });
            return this.ReturnObject(result);
        } catch (err: any) {
            return this.ReturnError(err);
        }
    }

}
